var mapAsync = function mapAsync(array, callbackfn) {
  return Promise.all(array.map(callbackfn));
};

export default mapAsync;